import * as React from 'react'
import { FC } from 'react'
import { MdCancel } from 'react-icons/md'
import Button from './button'
import RecruiterSearchCompletion from './recruiter_search_completion'
import { FormField } from './form_field'
import styles from './recruiter_selector.module.scss'
import Recruiter from 'entities/recruiter'
import { MdSearch } from 'react-icons/md'

type Props = {
  keyword: string
  recruiters: Recruiter[]
  selectedRecruiter: Recruiter | null
  onChangeKeywordForRecruiter: (keyword: string) => void
  onSelectRecruiter: (recruiter: Recruiter) => void
  onDeselectRecruiter: () => void
  selectable: boolean
}

const RecruiterSelector: FC<Props> = ({
  keyword,
  recruiters,
  selectedRecruiter,
  onChangeKeywordForRecruiter,
  onSelectRecruiter,
  onDeselectRecruiter,
  selectable
}) => (
  <>
    <div className={styles.wrapper}>
      {selectedRecruiter === null ? (
        <>
          <FormField
            id="recruiter_name"
            isActive={recruiters.length !== 0}
            label={I18n.t('offers.pages.show.components.recruiter_selector.search_field_label')}
            name="recruiter[name]"
            required
            value={keyword}
            onChange={(keyword: string) => onChangeKeywordForRecruiter(keyword)}
            readOnly={!selectable}
            icon={<MdSearch size={24} />}
          />
          <RecruiterSearchCompletion
            keyword={keyword}
            recruiters={recruiters}
            selectedRecruiter={selectedRecruiter}
            onSelectRecruiter={onSelectRecruiter}
          />
        </>
      ) : (
        <>
          <div className={styles.selectedRecruiterLabel}>
            {I18n.t('offers.pages.show.components.recruiter_selector.selected_recruiter_label')}
          </div>
          <div className={styles.selectedRecruiterContainer}>
            <div className={styles.selectedRecruiterName}>{selectedRecruiter.name}</div>
            {selectable ? (
              <Button
                className={styles.cancelButton}
                disabled={selectedRecruiter === null}
                onClick={() => onDeselectRecruiter()}
              >
                <MdCancel size={32} />
              </Button>
            ) : null}
          </div>
        </>
      )}
    </div>
  </>
)

export default RecruiterSelector
